import { AccountClient, GET_CLIENTS } from '@nile/graphql';
import { GET_CONSTANTS } from '@nile/components';
import { timezones } from '@nile/banyan/src/Constants/timezone';
import { GET_HOLIDAYS } from '@nile/banyan/src/Graphql/Mutations/holiday';

export const getClient = (field) => {
  return AccountClient;
};

export const getVariables = (field) => {
  switch (field) {
    case 'siteHolidayListId':
      return {};
    case 'clientId':
      return { listInfo: {} };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'siteHolidayListId':
      return GET_HOLIDAYS;
    case 'clientId':
      return GET_CLIENTS;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    case 'siteHolidayListId':
    case 'clientId':
      return client?.query({ query, variables });
    default:
      return [];
  }
};

export const getSelectOptions = (field) => {
  switch (field) {
    case 'siteTimezoneCode':
      return timezones
        .reduce((acc, zone) => [...acc, ...zone.utc], [])
        .map((zoneCode) => ({ value: zoneCode, label: zoneCode }));
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    case 'siteHolidayListId':
      return 'getAllHolidayList';
    case 'clientId':
      return 'getClientList';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'siteHolidayListId':
      return options?.data?.[key].map((el) => {
        return {
          value: el.id,
          label: el.name
        };
      });
    case 'clientId':
      return options?.data?.[key].clients.map((el) => {
        return {
          value: el.accountId,
          label: el.name
        };
      });
    case 'siteState':
      return options.map((state) => ({
        value: state.isoCode,
        label: state.name,
        isoCode: state.isoCode,
        name: state.name
      }));
    case 'siteCountry':
      return options.map((country) => ({
        value: country.isoCode,
        label: country.name,
        isoCode: country.isoCode,
        name: country.name
      }));
    default:
      return options;
  }
};

export const getSiteValidationFields = () => {
  return {};
};

export const modelSiteValidationFields = () => {
  return null;
};
const STATE_LIST_JSON_FILE_NAME = 'states';
const COUNTRY_LIST_JSON_FILE_NAME = 'country';
export const getSiteImportFields = (currentProduct) => {
  const siteListFields = [
    {
      label: 'dromo.title.siteName',
      key: 'siteName',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        // {
        //   validate: 'unique_case_insensitive',
        //   errorMessage: 'dromo.validation.unique'
        // },
        {
          validate: 'require_with',
          fields: [
            'siteContactNumber',
            'siteLine1',
            'siteLine2',
            'siteLine3',
            'siteCountry',
            'siteCity',
            'siteState',
            'sitePostalCode',
            'siteTimezoneCode',
            'siteHolidayListId'
          ],
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'dromo.title.phoneNumber',
      key: 'siteContactNumber'
    },
    {
      label: 'dromo.title.hqSiteLine1',
      key: 'siteLine1'
    },
    {
      label: 'dromo.title.hqSiteLine2',
      key: 'siteLine2'
    },
    {
      label: 'dromo.title.hqSiteLine3',
      key: 'siteLine3'
    },
    {
      label: 'dromo.title.hqSiteCountry',
      key: 'siteCountry',
      type: 'select',
      selectOptions: GET_CONSTANTS(COUNTRY_LIST_JSON_FILE_NAME)
    },
    {
      label: 'dromo.title.hqSiteState',
      key: 'siteState',
      type: 'select',
      selectOptions: GET_CONSTANTS(STATE_LIST_JSON_FILE_NAME)
    },
    {
      label: 'dromo.title.hqSiteCity',
      key: 'siteCity'
    },
    {
      label: 'dromo.title.hqSitePostalCode',
      key: 'sitePostalCode'
    },
    // {
    //   label: 'dromo.title.hqSiteTimezoneCode',
    //   key: 'siteTimezoneCode',
    //   type: 'select',
    //   selectOptions: getSelectOptions('siteTimezoneCode')
    // },
    {
      label: 'dromo.title.holidayList',
      key: 'siteHolidayListId',
      type: 'select',
      selectOptions: getSelectOptions('siteHolidayListId')
    }
  ];
  if (currentProduct == 'MSP') {
    siteListFields.splice(0, 0, {
      label: 'dromo.title.clientName',
      key: 'clientId',
      type: 'select',
      selectOptions: getSelectOptions('clientId'),
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    });
  }

  return siteListFields;
};
